import React from 'react';
import { SearchIcon } from 'lucide-react';
interface BidFiltersProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  statusFilter: string;
  setStatusFilter: (status: string) => void;
  categoryFilter: string;
  setCategoryFilter: (category: string) => void;
}
export function BidFilters({
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  categoryFilter,
  setCategoryFilter
}: BidFiltersProps) {
  const categories = ['All Categories', 'Health & Medical', 'Infrastructure', 'Education & Training', 'Consulting Services', 'Agriculture', 'Energy', 'Technology', 'Economic Development', 'Food, Beverages & FMCG'];
  return <div className="bg-white rounded-lg border border-gray-border p-6 mb-8" data-id="element-79" data-mp="182j8d0xjs714">
      <div className="grid md:grid-cols-3 gap-4" data-id="element-80" data-mp="3nuqcbi0ob3j6">
        <div data-id="element-81" data-mp="3nsx5a1m5ehan">
          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-82" data-mp="3nwkyt0rlf3pd">
            Search
          </label>
          <div className="relative" data-id="element-83" data-mp="3sr70udbsbjws">
            <SearchIcon size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-84" data-mp="39fjht45q9ha1" />
            <input type="text" placeholder="Search bids..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-border rounded-lg focus:outline-none focus:ring-2 focus:ring-au-green" data-id="element-85" data-mp="34j2s45ivquuu" />
          </div>
        </div>

        <div data-id="element-86" data-mp="3nf1c1z1slmqs">
          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-87" data-mp="3nfktlenj694a">
            Status
          </label>
          <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="w-full px-4 py-2 border border-gray-border rounded-lg focus:outline-none focus:ring-2 focus:ring-au-green" data-id="element-88" data-mp="51bk0ram3eb3">
            <option value="all" data-id="element-89" data-mp="a1z9h8j6zn37">All Status</option>
            <option value="open" data-id="element-90" data-mp="9z3bxlb9b0fa">Open</option>
            <option value="closing-soon" data-id="element-91" data-mp="33tpg2n6hgwol">Closing Soon</option>
            <option value="closed" data-id="element-92" data-mp="33rcqbnuhhi0z">Closed</option>
          </select>
        </div>

        <div data-id="element-93" data-mp="37v0ya7n12fmr">
          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-94" data-mp="37set2enm0c7p">
            Category
          </label>
          <select value={categoryFilter} onChange={e => setCategoryFilter(e.target.value)} className="w-full px-4 py-2 border border-gray-border rounded-lg focus:outline-none focus:ring-2 focus:ring-au-green" data-id="element-95" data-mp="3hkkjvl24knlb">
            {categories.map(cat => <option key={cat} value={cat} data-id="element-96" data-mp="3vkc1dvruom42">
                {cat}
              </option>)}
          </select>
        </div>
      </div>
    </div>;
}